export default __webpack_public_path__ + "static/media/card-choice.91f4c285.svg";